export interface DescriptiveColumnConfig {
  key: string;
  label: string;
  description: string;
  helpText: string;
  dataType: 'string' | 'number';
  required?: boolean;
  maxLength?: number;
}

export const DESCRIPTIVE_COLUMNS_CONFIG: Record<string, DescriptiveColumnConfig> = {
  sku: {
    key: 'sku',
    label: 'SKU',
    description: 'Stock Keeping Unit identifier',
    helpText: 'Stock Keeping Unit identifier for internal sales tracking.',
    dataType: 'string',
    maxLength: 50,
  },
  skuDescription: {
    key: 'skuDescription',
    label: 'SKU Description',
    description: 'Descriptive text for the SKU',
    helpText: 'Descriptive text for the SKU for better identification.',
    dataType: 'string',
    maxLength: 200,
  },
  // Easy to add more columns here without touching component code!
};

export type DescriptiveColumnKey = keyof typeof DESCRIPTIVE_COLUMNS_CONFIG;

// Helper functions
export function getColumnConfig(key: string): DescriptiveColumnConfig | undefined {
  return DESCRIPTIVE_COLUMNS_CONFIG[key];
}

export function getAllColumnConfigs(): DescriptiveColumnConfig[] {
  return Object.values(DESCRIPTIVE_COLUMNS_CONFIG);
}

export function getAvailableColumnKeys(): string[] {
  return Object.keys(DESCRIPTIVE_COLUMNS_CONFIG);
}
